import ModalPlugin from "@/common/plugins/ModalPlugin.js";

const offModalEvent = {
    methods: {
        offEventName(eventName) {
            ModalPlugin.EventBus.$off(eventName);
        }
    }
};

export default offModalEvent;